import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiRSelect, UiClientSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Form from 'react-bootstrap/Form';

import { Table } from 'antd';
import { Dropdown, Popconfirm, Menu } from 'antd';
import { MdOutlineMoreVert } from "react-icons/md";

export default function Colors() {
  let navigate = useNavigate();
  const location = useLocation();
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [tableDisable, setTableDisable] = useState(false);
  const [state, setState] = useState([]);
  const [filterText, setFilterText] = React.useState('');
  const [filteredItems, setFilteredItems] = useState([]);


  const handleDelete = (id) => {
    var tid = id.toString();

    setTableDisable(true)
    instance
      .get("/update_color.php?delete=" + tid)
      .then(function (response) {
        setTableDisable(false)
        if (response.data.status == 'success') {
          fetchData();
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }
      })
  }





  const fetchData = () => {

    instance
      .get("/colors.php")
      .then(function (response) {
        setState(response.data)
        if (response.data.items.length > 0) {
          const filteredItems1 = response.data.items.filter(
            item => item.name && item.name.toLowerCase().includes(filterText.toLowerCase()),
          );
          setFilteredItems(filteredItems1)
        }
      })
      .catch(function (error) { })
      .then(function () { });
  }



  const colorModal = useModal('color');

  const addColor = (id, row) => {
    colorModal.show({ id: id, data: row }).then((res) => {
      fetchData()
    });
  }



  const items = (e) => [
    {
      key: '1',
      label: <span>Edit</span>,
      onClick: () => addColor(e.id, e),
    },
    {
      key: '2',
      label: (
        <Popconfirm
          title="Delete?"
          description="Are you sure to delete this?"
          onConfirm={() => handleDelete(e.id)}
          okText="Yes"
          cancelText="No"
        >
          <span>Delete</span>
        </Popconfirm>
      ),
    },


  ];



  const columns = [
    {
      title: 'Name',
      width: '380px',
      dataIndex: 'name',
    },





    {
      title: '',
      fixed: 'right',
      width: '23px',
      render: (text, row) => (
        <div className="tableaction1">
          <Dropdown menu={{
            items: items(row),
          }}
            trigger={['click']}
          >
            <button className='btn btn-light'><MdOutlineMoreVert /></button>


          </Dropdown>

        </div>


      )
    },

  ];


  useEffect(() => {
    fetchData();
  }, []);



  useEffect(() => {
    if (state.items) {
      const filteredItems1 = state.items.filter(
        item => item.name && item.name.toLowerCase().includes(filterText.toLowerCase()),
      );
      setFilteredItems(filteredItems1)
    }
  }, [filterText]);






  return (
    <>
      <Helmet>
        <title>
          Colors
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Colors" >
<div>
<CSVLink data={filteredItems} filename={"colors.csv"} headers={[{label: "Name", key: "name"}]} className="btn btn-secondary me-2">Download</CSVLink>

</div>
            <UiButton className="btn btn-primary" onClick={() => addColor('new')} title="Add" icon="add" ></UiButton>


          </PageHeader>

          <div className="mt-3">
            <Form.Group className="mb-3" >
              <Form.Control type="text" name="name1" placeholder="Search" value={filterText} onChange={e => setFilterText(e.target.value)} />

            </Form.Group>
          </div>
          <div className="position-relative bg-white rounded mb-4">





            <Table
              locale={{
                emptyText: (<TableZero title="Colors" />)
              }}

              size="small"
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={filteredItems}
              loading={{ spinning: (tableDisable) }}
              scroll={{
                x: 960,

              }}
            />


          </div>
        </div>
      </div>
    </>
  );
}
